import React, { Component } from 'react';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';
import { size as _size } from 'lodash';
import { Stage, Layer, Rect, Text, Circle, Line, Group } from 'react-konva';

import { alphabets as _alphabets } from './WordSearchAlphabets.js';

import Spinner from '../builder/Spinner.js';

const Legend = (props) => {
	const items = props.items;

	return (
		<div class="game_legend gui_main_text_color_on_bg">
			{items.map((item, i) => {
				const item_found = (item.found != undefined && item.found) ? item.found : false;

				return (
					<span key={i} class={'cutTextOnOverflow' + ((item_found) ? ' selected' : '')}><span class="___original_color_item">{item.word}</span></span>
				)
			})}
		</div>
	)
}

class WordSearchCanvas extends Component {
	constructor(props, context) {
		super(props, context);
		var min_size_words = 0;
		if(props.words != undefined) {
			props.words.map((word, i) => {
				if(_size(word) > min_size_words) min_size_words = _size(word);
			});

			if(props.columns != undefined) {
				min_size_words = (props.columns > min_size_words) ? props.columns : min_size_words;
			}
		} else {
			min_size_words = 5;
		}

		this.state = {
			columns:min_size_words,
			display_zoom_helper:false,
			end_line:{ x:false, y:false },
			full_loaded:false,
			level:(props.level != undefined) ? props.level : 'easy',
			theme:(props.theme != undefined) ? props.theme : 'light',
			charset_preset:(props.charset_preset != undefined) ? props.charset_preset : 'latin',
			custom_charset:(props.custom_charset != undefined) ? props.custom_charset : '',
			color_ok:(props.color_ok != undefined) ? props.color_ok : '255,255,255',
			move_direction:false,
			puzzle:[],
			result:{},
			start_line:{ x:false, y:false },
			words:(props.words != undefined) ? props.words.sort() : [],
			zoom_helper:{
				x_inverted:false,
				y_inverted:false,
			},
		};

		this.zoom_helper_enabled = false;
		

		this.word_init = {
			x:-1,
			y:-1,
		};

		this.word_end = {
			x:-1,
			y:-1,
		};

		this.size = 600;

		this.creating_color = props.color_ok;

		this.ko_color = props.color_ko;

		this.allOrientations = [];
		this.orientations = {
			horizontal:(x, y, i) => {
				return {
					x:x + i,
					y:y,
				};
			},
			horizontalBack:(x, y, i) => {
				return {
					x:x - i,
					y:y,
				};
			},
			vertical:(x, y, i) => {
				return {
					x:x,
					y:y + i,
				};
			},
			verticalUp:(x, y, i) => {
				return {
					x:x,
					y:y - i,
				};
			},
			diagonal:(x, y, i) => {
				return {
					x:x + i,
					y:y + i,
				};
			},
			diagonalBack:(x, y, i) => {
				return {
					x:x - i,
					y:y + i,
				};
			},
			diagonalUp:(x, y, i) => {
				return {
					x:x + i,
					y:y - i,
				};
			},
			diagonalUpBack:(x, y, i) => {
				return {
					x:x - i,
					y:y - i,
				};
			},
		};

		// Determines if an orientation is possible given the starting square (x,y),
		// the height (h) and width (w) of the puzzle, and the length of the word (l).
		// Returns true if the word will fit starting at the square provided using
		// the specified orientation.
		this.checkOrientations = {
			horizontal:(x, y, h, w, l) => {
				return (w >= x + l) ? true : false;
			},
			horizontalBack:(x, y, h, w, l) => {
				return (x + 1 >= l) ? true : false;
			},
			vertical:(x, y, h, w, l) => {
				return (h >= y + l) ? true : false;
			},
			verticalUp:(x, y, h, w, l) => {
				return (y + 1 >= l) ? true : false;
			},
			diagonal:(x, y, h, w, l) => {
				return ((w >= x + l) && (h >= y + l)) ? true : false;
			},
			diagonalBack:(x, y, h, w, l) => {
				return ((x + 1 >= l) && (h >= y + l)) ? true : false;
			},
			diagonalUp:(x, y, h, w, l) => {
				return ((w >= x + l) && (y + 1 >= l)) ? true : false;
			},
			diagonalUpBack:(x, y, h, w, l) => {
				return ((x + 1 >= l) && (y + 1 >= l)) ? true : false;
			},
		};

		// Determines the next possible valid square given the square (x,y) was ]
		// invalid and a word lenght of (l).  This greatly reduces the number of
		// squares that must be checked. Returning {x: x+1, y: y} will always work
		// but will not be optimal.
		this.skipOrientations = {
			horizontal:(x, y, l) => {
				return {
					x:0,
					y:y + 1,
				};
			},
			horizontalBack:(x, y, l) => {
				return {
					x:l - 1,
					y:y,
				};
			},
			vertical:(x, y, l) => {
				return {
					x:0,
					y:y + 100,
				};
			},
			verticalUp:(x, y, l) => {
				return {
					x:0,
					y:l - 1,
				};
			},
			diagonal:(x, y, l) => {
				return {
					x:0,
					y:y + 1,
				};
			},
			diagonalBack:(x, y, l) => {
				return {
					x:l - 1,
					y:(x >= l - 1) ? (y + 1) : y,
				};
			},
			diagonalUp:(x, y, l) => {
				return {
					x:0,
					y:(y < l - 1) ? (l - 1) : (y + 1),
				};
			},
			diagonalUpBack:(x, y, l) => {
				return {
					x:l - 1,
					y:x >= (l - 1) ? (y + 1) : y,
				};
			},
		};

		window.handleWordSearchCanvas = this;
		this.setDifficultLevel();

		this.hover_sound = props.sound_fx.selecting;
		this.error_sound = props.sound_fx.error;
		this.success_sound = props.sound_fx.success;

		if(props.stageInstance != undefined) props.stageInstance(this);

		this.default_cache_props = { pixelRatio:2, imageSmoothingEnabled:true, offset:5, drawBorder:false };
	}

	/*START SOUNDS*/
	hoverPlay() {
		this.hover_sound.play();
	}

	hoverStop(cb) {
		this.hover_sound.fade(1, 0, 200);
		this.hover_sound.once('fade', () => {
			this.hover_sound.stop();
			this.hover_sound.volume(1);

			if(cb !== undefined && cb == 'success') {
				this.successPlay();
			} else {
				this.errorPlay();
			}
		});
	}

	errorPlay() {
		this.error_sound.play();
	}

	successPlay() {
		this.success_sound.play();
	}
	/*END SOUNDS*/

	componentWillMount() {
		this.resetGame(true);

		this.solve();
	}

	componentDidMount() {
		const t = setTimeout(() => {
			this.gameInit();
		}, ((!this.is_builder) ? 100 : 100));

		window.onresize = () => {
			this.setState({ full_loaded:true });
			this.gameInit(true);
		}
	}

	componentWillReceiveProps(props) {
		var changes_puzzle = false;
		if (JSON.stringify(props.words) != JSON.stringify(this.state.words)) {
			changes_puzzle = true;
		}
		const fields_to_change = ['words','columns','level','theme','charset_preset','custom_charset','color_ok'];
		fields_to_change.map((item,i)=>{
			if(props[item] != this.props[item]) {
				this.state[item] = props[item];
				changes_puzzle = true;
			}
		});

		

		if(props.to_reset != this.props.to_reset) {
			this.resetGame();
		}

		if(changes_puzzle) {
			this.setDifficultLevel();
			this.state.puzzle = this.newPuzzle({
				fillBlanks:true,
				height:this.state.columns,
				width:this.state.columns,
			});
			this.solve();
			this.gameInit();
			this.setState({...this.state});
		}
		if(this.refs.stage != undefined)this.refs.stage.draw();
	}

	resetGame(onInit) {
		if(onInit == undefined)onInit = false;

		//var num_puzzles = 0;
		var puzzzle = [];
		while(_size(puzzzle)>this.state.columns || _size(puzzzle) == 0){
			//num_puzzles++;
			puzzzle = this.newPuzzle({
				fillBlanks:true,
				height:this.state.columns,
				width:this.state.columns,
			});
		}
		this.state.puzzle = puzzzle;

		if(!onInit) {
			this.state.full_loaded = false;
			this.setState({...this.state});
			this.solve();
			this.gameInit();
		} else {
			this.setState({...this.state});
		}
	}

	gameInit(from_resize) {
		if(from_resize == undefined) from_resize = false;
		if(this.props.words.length > 0 && this.props.adaptToContainer != undefined) this.props.adaptToContainer((size) => {
			this.size = size;
			this.setState({ full_loaded:true });

			setTimeout(() => {
				if(this.refs.letters == undefined) return;
				this.refs.letters.clearCache();
				this.refs.letters.cache(this.default_cache_props);
				this.refs.layer.draw();
			}, 50);
		});
		else {
			this.setState({ full_loaded:true });
		}
	}

	getMainTextDirection() {
		var is_ltr = true;
		switch(this.state.charset_preset) {
			case 'arabic':
			case 'hebrew':
				is_ltr = false;
				break;
			default:
				break;
		}
		return is_ltr;
	}

	setDifficultLevel() {
		const is_ltr = this.getMainTextDirection();

		switch(this.state.level) {
			case 'hard':
				this.allOrientations.push('diagonalBack');
				this.allOrientations.push('diagonalUpBack');
				this.allOrientations.push('verticalUp');
				this.allOrientations.push((is_ltr) ? 'horizontalBack' : 'horizontal');

			case 'normal':
				this.allOrientations.push('diagonalUp');
				this.allOrientations.push('diagonal');

			case 'easy':
			default:
				this.allOrientations.push((is_ltr) ? 'horizontal' : 'horizontalBack');
				this.allOrientations.push('vertical');
				break;
		}

		//this.setState({...this.state});
	}

	/**
	* Initializes the puzzle and places words in the puzzle one at a time.
	*
	* Returns either a valid puzzle with all of the words or null if a valid
	* puzzle was not found.
	*
	* @param {[String]} words: The list of words to fit into the puzzle
	* @param {[Options]} options: The options to use when filling the puzzle
	*/
	fillPuzzle(words, options) {
		var puzzle = [], i, j, len;

		// initialize the puzzle with blanks
		for(i = 0; i < options.height; i++) {
			puzzle.push([]);
			for(j = 0; j < options.width; j++) puzzle[i].push('');
		}

		// add each word into the puzzle one at a time
		for(i = 0, len = words.length; i < len; i++) {
			puzzle = this.placeWordInPuzzle(puzzle, options, words[i]);
			if(!puzzle) {
				//if a word didn't fit in the puzzle, give up
				return null;
			}
		}

		// return the puzzle
		return puzzle;
	}

	/**
	* Adds the specified word to the puzzle by finding all of the possible
	* locations where the word will fit and then randomly selecting one. Options
	* controls whether or not word overlap should be maximized.
	*
	* Returns true if the word was successfully placed, false otherwise.
	*
	* @param {[[String]]} puzzle: The current state of the puzzle
	* @param {[Options]} options: The options to use when filling the puzzle
	* @param {String} word: The word to fit into the puzzle.
	*/
	placeWordInPuzzle(puzzle, options, word) {
		// find all of the best locations where this word would fit
		const locations = this.findBestLocations(puzzle, options, word);

		if(locations.length === 0) return false;

		// select a location at random and place the word there
		var sel = locations[Math.floor(Math.random() * locations.length)];
		this.placeWord(puzzle, word, sel.x, sel.y, this.orientations[sel.orientation]);

		return puzzle;
	}

	/**
	* Iterates through the puzzle and determines all of the locations where
	* the word will fit. Options determines if overlap should be maximized or
	* not.
	*
	* Returns a list of location objects which contain an x,y cooridinate
	* indicating the start of the word, the orientation of the word, and the
	* number of letters that overlapped with existing letter.
	*
	* @param {[[String]]} puzzle: The current state of the puzzle
	* @param {[Options]} options: The options to use when filling the puzzle
	* @param {String} word: The word to fit into the puzzle.
	*/
	findBestLocations(puzzle, options, word) {
		var locations = [],
			height = options.height,
			width = options.width,
			wordLength = this.unicodeLength(word),
			maxOverlap = 0; // we'll start looking at overlap = 0

		// loop through all of the possible orientations at this position
		for(var k = 0, len = options.orientations.length; k < len; k++) {
			var orientation = options.orientations[k],
				check = this.checkOrientations[orientation],
				next = this.orientations[orientation],
				skipTo = this.skipOrientations[orientation],
				x = 0, y = 0;

			// loop through every position on the board
			while(y < height) {
				// see if this orientation is even possible at this location
				if(check(x, y, height, width, wordLength)) {
					// determine if the word fits at the current position
					var overlap = this.calcOverlap(word, puzzle, x, y, next);

					// if the overlap was bigger than previous overlaps that we've seen
					if(overlap >= maxOverlap || (!options.preferOverlap && overlap > -1)) {
						maxOverlap = overlap;
						locations.push({x:x, y:y, orientation:orientation, overlap:overlap});
					}

					x++;
					if(x >= width) {
						x = 0;
						y++;
					}
				} else {
					// if current cell is invalid, then skip to the next cell where
					// this orientation is possible. this greatly reduces the number
					// of checks that we have to do overall
					var nextPossible = skipTo(x, y, wordLength);
					x = nextPossible.x;
					y = nextPossible.y;
				}
			}
		}

		// finally prune down all of the possible locations we found by
		// only using the ones with the maximum overlap that we calculated
		return options.preferOverlap ? this.pruneLocations(locations, maxOverlap) : locations;
	}

	findStartAndEndWord(object_word) {
		//'horizontal', 'horizontalBack', 'vertical', 'verticalUp', 'diagonal', 'diagonalUp', 'diagonalBack', 'diagonalUpBack'
		const init_x = object_word.x;
		const init_y = object_word.y;
		var end_x = object_word.x;
		var end_y = object_word.y;

		switch(object_word.orientation){
			case 'horizontal':
				//Grow X
				end_x += object_word.overlap - 1;
				break;
			case 'horizontalBack':
				//Reduce X
				end_x -= object_word.overlap - 1;
				break;
			case 'vertical':
				//Grow Y
				end_y += object_word.overlap - 1;
				break;
			case 'verticalUp':
				//Reduce Y
				end_y -= object_word.overlap - 1;
				break;
			case 'diagonal':
				//Grow X & Y
				end_x += object_word.overlap - 1;
				end_y += object_word.overlap - 1;
				break;
			case 'diagonalUp':
				//Grow X & Reduce Y
				end_x += object_word.overlap - 1;
				end_y -= object_word.overlap - 1;
				break;
			case 'diagonalBack':
				//Reduce X & Grow Y
				end_x -= object_word.overlap - 1;
				end_y += object_word.overlap - 1;
				break;
			case 'diagonalUpBack':
				//Reduce X & Reduce Y
				end_x -= object_word.overlap - 1;
				end_y -= object_word.overlap - 1;
				break;
		}

		return {
			end:[end_x, end_y],
			start:[init_x, init_y],
		};
	}

	/**
	* Determines whether or not a particular word fits in a particular
	* orientation within the puzzle.
	*
	* Returns the number of letters overlapped with existing words if the word
	* fits in the specified position, -1 if the word does not fit.
	*
	* @param {String} word: The word to fit into the puzzle.
	* @param {[[String]]} puzzle: The current state of the puzzle
	* @param {int} x: The x position to check
	* @param {int} y: The y position to check
	* @param {function} fnGetSquare: Function that returns the next square
	*/
	calcOverlap(word, puzzle, x, y, fnGetSquare) {
		var overlap = 0;

		// traverse the squares to determine if the word fits
		for(var i = 0, len = this.unicodeLength(word); i < len; i++) {
			var next = fnGetSquare(x, y, i),
				square = puzzle[next.y][next.x];

			// if the puzzle square already contains the letter we
			// are looking for, then count it as an overlap square
			if(square === [...word][i]) {
				overlap++;
			} else if(square !== '') {
				// if it contains a different letter, than our word doesn't fit
				// here, return -1
				return -1;
			}
		}

		// if the entire word is overlapping, skip it to ensure words aren't
		// hidden in other words
		return overlap;
	}

	/**
	* If overlap maximization was indicated, this function is used to prune the
	* list of valid locations down to the ones that contain the maximum overlap
	* that was previously calculated.
	*
	* Returns the pruned set of locations.
	*
	* @param {[Location]} locations: The set of locations to prune
	* @param {int} overlap: The required level of overlap
	*/
	pruneLocations(locations, overlap) {
		var pruned = [];
		for(var i = 0, len = locations.length; i < len; i++) {
			if(locations[i].overlap >= overlap) pruned.push(locations[i]);
		}

		return pruned;
	}

	unicodeLength(str) {
		return [...str].length;
	}

	unicodeToChar(text) {
		return String.fromCharCode(parseInt(text), 16);
	}

	/**
	* Places a word in the puzzle given a starting position and orientation.
	*
	* @param {[[String]]} puzzle: The current state of the puzzle
	* @param {String} word: The word to fit into the puzzle.
	* @param {int} x: The x position to check
	* @param {int} y: The y position to check
	* @param {function} fnGetSquare: Function that returns the next square
	*/
	placeWord(puzzle, word, x, y, fnGetSquare) {
		for(var i = 0, len = this.unicodeLength(word); i < len; i++) {
			var next = fnGetSquare(x, y, i);
			//puzzle[next.y][next.x] = word[i];
			puzzle[next.y][next.x] = [...word][i];
		}
		return puzzle;
	}

	newPuzzle(settings) {
		var words = this.state.words;
		var wordList, puzzle, attempts = 0, opts = settings || {};

		// copy and sort the words by length, inserting words into the puzzle
		// from longest to shortest works out the best
		wordList = words.slice(0).sort(function (a, b) {
			return (a.length < b.length) ? 1 : 0;
		});

		// initialize the options
		var options = {
			height:			opts.height || this.unicodeLength(wordList[0]),
			width:			opts.width || this.unicodeLength(wordList[0]),
			orientations:	opts.orientations || this.allOrientations,
			fillBlanks:		(opts.fillBlanks !== undefined) ? opts.fillBlanks : true,
			maxAttempts:	opts.maxAttempts || 3,
			preferOverlap:	(opts.preferOverlap !== undefined) ? opts.preferOverlap : true
		};

		// add the words to the puzzle
		// since puzzles are random, attempt to create a valid one up to
		// maxAttempts and then increase the puzzle size and try again
		while(!puzzle) {
			while(!puzzle && attempts++ < options.maxAttempts) {
				puzzle = this.fillPuzzle(wordList, options);
			}

			if(!puzzle) {
				options.height++;
				options.width++;
				attempts = 0;
			}
		}

		// fill in empty spaces with random letters
		if(options.fillBlanks) {
			puzzle = this.fillBlanks(puzzle, options);
		}

		return puzzle;
	}

	convertCustomCharsToArray() {
		const custom_chars = (this.state.custom_charset != "") ? this.state.custom_charset.split(",") : [];
		return custom_chars;
	}

	getCharactersInGame() {
		const default_alphabet = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'];
		const alphabet = _alphabets.find((obj) => { return  obj.id == this.state.charset_preset; });
		
		let charset = (alphabet) ? alphabet.charset : default_alphabet;
		if(this.state.custom_charset.length > 0) {
			charset = charset.concat(this.convertCustomCharsToArray());
		}

		return charset;
	}

	/**
	* Fills in any empty spaces in the puzzle with random letters.
	*
	* @param {[[String]]} puzzle: The current state of the puzzle
	* @api public
	*/
	fillBlanks(puzzle) {
		const charset = this.getCharactersInGame();

		for(var i = 0, height = puzzle.length; i < height; i++) {
			var row = puzzle[i];
			for(var j = 0, width = row.length; j < width; j++) {
				if(!puzzle[i][j]) {
					var randomLetter = Math.floor(Math.random() * charset.length);
					puzzle[i][j] = charset[randomLetter];
				}
			}
		}
		return puzzle;
	}

	/**
	* Returns the starting location and orientation of the specified words
	* within the puzzle. Any words that are not found are returned in the
	* notFound array.
	*
	* Returns
	*   x position of start of word
	*   y position of start of word
	*   orientation of word
	*   word
	*   overlap (always equal to word.length)
	*
	* @param {[[String]]} puzzle: The current state of the puzzle
	* @param {[String]} words: The list of words to find
	* @api public
	*/
	solve() {
		const puzzle = this.state.puzzle;
		const words = this.state.words;

		var options = {
			height:			puzzle.length,
			width:			puzzle[0].length,
			orientations:	this.allOrientations,
			preferOverlap:	true,
		},
		found = [],
		notFound = [];

		for(var i = 0, len = words.length; i < len; i++) {
			var word = words[i],
				locations = this.findBestLocations(puzzle, options, word);
			if(locations.length > 0 && locations[0].overlap === this.unicodeLength(word)) {
				var word_position = this.findStartAndEndWord({x:locations[0].x, y: locations[0].y, orientation: locations[0].orientation, overlap: locations[0].overlap})
				locations[0].word = word;
				locations[0].start = word_position.start;
				locations[0].end = word_position.end
				found.push(locations[0]);
			} else {
				notFound.push(word);
			}
		}

		this.state.result = {
			found:found,
			notFound:notFound,
		};

		this.setState({...this.state});
	}

	/**
	* Outputs a puzzle to the console, useful for debugging.
	* Returns a formatted string representing the puzzle.
	*
	* @param {[[String]]} puzzle: The current state of the puzzle
	* @api public
	*/
	print() {
		var puzzleString = '';
		for(var i = 0, height = this.state.puzzle.length; i < height; i++) {
			var row = this.state.puzzle[i];
			for(var j = 0, width = row.length; j < width; j++) {
				puzzleString += (row[j] === '' ? ' ' : row[j]) + ' ';
			}
			puzzleString += '\n';
		}

		return puzzleString;
	}

	isSolved() {
		var is_solved = true;
		(this.state.result.found).map((item, i) => {
			if(item.found == undefined || !item.found) is_solved = false
		});


		if(is_solved) {

			const stage = this.refs['stage'];
			/*stage.toImage({
				callback: (img) => {
					if(this.props.onSolve != undefined) this.props.onSolve(is_solved,{img:img});
				}
			});*/
			if(this.props.onSolve != undefined) this.props.onSolve(is_solved, {img:stage.toDataURL()});
		}

		return is_solved;
	}

	//Functions text
	handleMouseOver(e) {
		const attrs = e.target.attrs;
		var stage = this.refs['stage'];

		if(this.state.start_line.x !== false) {
			if(this.state.start_line.x == this.state.end_line.x && this.state.start_line.y == this.state.end_line.y) {
				this.state.move_direction = false;
			}

			if(this.state.move_direction === false) {
				this.state.end_line = {
					x:attrs.pos_x,
					y:attrs.pos_y,
				};

				this.getMoveDirection();
			} else {
				const displace = Math.min(Math.abs(attrs.pos_x - this.state.start_line.x), Math.abs(attrs.pos_y - this.state.start_line.y));

				switch(this.state.move_direction) {
					case 'diagonal':
						this.state.end_line.x = this.state.start_line.x + displace;
						this.state.end_line.y = this.state.start_line.y + displace;
						break;
					case 'diagonalBack':
						this.state.end_line.x = this.state.start_line.x - displace;
						this.state.end_line.y = this.state.start_line.y + displace;
						break;
					case 'diagonalUp':
						this.state.end_line.x = this.state.start_line.x + displace;
						this.state.end_line.y = this.state.start_line.y - displace;
						break;
					case 'diagonalUpBack':
						this.state.end_line.x = this.state.start_line.x - displace;
						this.state.end_line.y = this.state.start_line.y - displace;
						break;
					case 'horizontal':
					case 'horizontalBack':
						this.state.end_line.x = attrs.pos_x;
						this.state.end_line.y = this.state.start_line.y;
						break;
					case 'vertical':
					case 'verticalUp':
						this.state.end_line.x = this.state.start_line.x;
						this.state.end_line.y = attrs.pos_y;
						break;
				}
			}
			//this.hoverPlay();
			this.setState({...this.state});
		}

		if(this.zoom_helper_enabled) this.checkZoomHelperPosition();

		const t = setTimeout(() => {
			this.automaticMouseUpOnEndPosition(e);
		}, 1000);
	}

	automaticMouseUpOnEndPosition(e) {
		const first_p = 0;
		const last_p = _size(this.state.puzzle) - 1;

		var do_mouse_up = false;
		switch(this.state.move_direction) {
			case 'diagonal':
				if(this.state.end_line.x == last_p || this.state.end_line.y == last_p) do_mouse_up = true;
				break;
			case 'diagonalBack':
				if(this.state.end_line.x == first_p || this.state.end_line.y == last_p) do_mouse_up = true;
				break;
			case 'diagonalUp':
				if(this.state.end_line.x == last_p || this.state.end_line.y == first_p) do_mouse_up = true;
				break;
			case 'diagonalUpBack':
				if(this.state.end_line.x == first_p || this.state.end_line.y == first_p) do_mouse_up = true;
				break;
			case 'horizontal':
				if(this.state.end_line.x == last_p) do_mouse_up = true;
				break;
			case 'horizontalBack':
				if(this.state.end_line.x == first_p) do_mouse_up = true;
				break;
			case 'vertical':
				if(this.state.end_line.y == last_p) do_mouse_up = true;
				break;
			case 'verticalUp':
				if(this.state.end_line.y == first_p) do_mouse_up = true;
				break;
		}

		if(do_mouse_up) this.handleMouseUp(false);
	}

	getMoveDirection() {
		const ini = this.state.start_line;
		const end = this.state.end_line;

		const x_diff = Math.abs(end.x - ini.x);
		const y_diff = Math.abs(end.y - ini.y);
		var angle = Math.atan(y_diff / x_diff) * 180 / Math.PI;
		if(isNaN(angle)) angle = 0;

		if(angle == 45) {
			if(ini.x < end.x && ini.y > end.y) {
				this.state.move_direction = 'diagonalUp';
			} else if(ini.x > end.x && ini.y > end.y) {
				this.state.move_direction = 'diagonalUpBack';
			} else if(ini.x < end.x && ini.y < end.y) {
				this.state.move_direction = 'diagonal';
			} else {
				this.state.move_direction = 'diagonalBack';
			}
		} else if(angle < 45) {
			this.state.move_direction = (ini.x < end.x) ? 'horizontal' : 'horizontalBack';
			this.state.end_line.y = this.state.start_line.y;
		} else {
			this.state.move_direction = (ini.y < end.y) ? 'vertical' : 'verticalUp';
			this.state.end_line.x = this.state.start_line.x;
		}
	}

	handleMouseDown(e) {
		this.hoverPlay();

		const attrs = e.target.attrs;

		this.state.start_line = {
			x:attrs.pos_x,
			y:attrs.pos_y,
		};

		this.state.end_line = {
			x:attrs.pos_x,
			y:attrs.pos_y,
		};

		if(this.zoom_helper_enabled) this.state.display_zoom_helper = true;

		this.setState({...this.state});
	}

	handleMouseUp(e) {
		this.checkWord();

		this.setState({
			display_zoom_helper:false,
			end_line:{
				x:false,
				y:false,
			},
			move_direction:false,
			start_line:{
				x:false,
				y:false,
			},
		});
	}

	checkZoomHelperPosition() {
		const box_size = Math.abs(this.size / _size(this.state.puzzle));
		const end_x = this.state.end_line.x * box_size + box_size / 2;
		const end_y = this.state.end_line.y * box_size + box_size / 2;

		const zoom_helper_width = box_size * 3;
		const zoom_helper_height = box_size * 3;
		const threshold = box_size;

		this.setState({
			zoom_helper:{
				x_inverted:((end_x - (zoom_helper_width + threshold) < 0) ? true : false),
				y_inverted:((end_y - (zoom_helper_height + threshold) < 0) ? true : false),
			},
		});
	}

	checkWord() {
		if(this.state.end_line.x !== false) {
			var first_letter = this.state.start_line;
			var last_letter = this.state.end_line;

			var is_solved = false;

			var word_found = (this.state.result.found).filter((obj) => {
				const check_word_in_logical_direction = obj.start[0] == first_letter.x && obj.start[1] == first_letter.y && obj.end[0] == last_letter.x && obj.end[1] == last_letter.y;
				const check_word_in_reverse_direction = obj.start[0] == last_letter.x && obj.start[1] == last_letter.y && obj.end[0] == first_letter.x && obj.end[1] == first_letter.y;
				return check_word_in_logical_direction || check_word_in_reverse_direction;
			})[0];
			var key_word_found = (this.state.result.found).indexOf(word_found);
			if(key_word_found > -1) {

				if(this.state.result.found[key_word_found]!=undefined && !this.state.result.found[key_word_found].found){
					//TOMA PREMIO
					this.state.result.found[key_word_found].found = true;

					this.setState({...this.state});
					if(this.props.onHitResult != undefined) this.props.onHitResult();

					this.hoverStop('success');
					is_solved = this.isSolved();
				}
			} else {
				//BAD WORD
				this.hoverStop('error');
			}

			if(this.props.onFireAttempt != undefined) this.props.onFireAttempt({
				error:!is_solved,
			}, is_solved);
		}
	}

	render() {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);

		const result = this.state.result;

		if(result.found == undefined || _size(result.found) === 0) {
			return (
				<aside class="game_container is_wordsearch">
					<div class="canvas_content">
						<img src={window.cdn_url + 'img/blank_1x1.png'} class="img_pusher" alt="" />
						<div class="is_fullscreen relative_to_container empty_game_warning not_awesome orangeBg knk-arrow-l-big">
							<span>{i18n("Start adding some words to generate the word search grid")}</span>
						</div>
					</div>
				</aside>
			)
		}

		const puzzle = this.state.puzzle;
		const words = this.state.words;

		const box_size = Math.abs(this.size / _size(puzzle));

		const canvas_size = box_size * this.state.columns;

		var count_word = 0;
		var count_word_mob = 0;
		var count_bg = 0;

		const theme = this.props?.theme ?? 'light';
		const bg_color = this.props?.bg_color ?? 'rgba(255, 255, 255, 1)';
		const text_color = this.props?.text_color ?? 'rgba(0, 0, 0, 1)';

		const zoom_area_radius = box_size;

		const pointer_ini_x = (this.state.start_line.x !== false) ? this.state.start_line.x * box_size + box_size / 2 : -this.size;
		const pointer_ini_y = (this.state.start_line.y !== false) ? this.state.start_line.y * box_size + box_size / 2 : -this.size;

		const pointer_x = (this.state.end_line.x !== false) ? this.state.end_line.x * box_size + box_size / 2 : -this.size;
		const pointer_y = (this.state.end_line.y !== false) ? this.state.end_line.y * box_size + box_size / 2 : -this.size;

		const display_legend = (this.props.display_legend != undefined) ? this.props.display_legend : true;
		const color_ok = this.state.color_ok;

		return (
			<aside class="game_container is_wordsearch">
				<div class={'canvas_content is_' + theme}>
					<img src={window.cdn_url + 'img/blank_1x1.png'} class="img_pusher" alt="" />
					{(this.state.full_loaded) ? (
						<Stage className={'canvas_cont' + ((!this.state.full_loaded) ? ' not_loaded_yet' : '')} width={this.size} height={this.size} ref="stage">
							<Layer ref="layer">
								<Rect
									x={0}
									y={0}
									fill={bg_color}
									width={this.size}
									height={this.size}
								/>

								{this.state.result.found.map((word, w) => {
									if(word.found == undefined) return null;

									const x1 = word.start[0] * box_size + box_size / 2;
									const y1 = word.start[1] * box_size + box_size / 2;
									const x2 = word.end[0] * box_size + box_size / 2;
									const y2 = word.end[1] * box_size + box_size / 2;

									return (
										<Line
											key={w + '_sel'}
											points={[x1, y1, x2, y2]}
											stroke={'rgba(' + color_ok + ', 1)'}
											lineCap='round'
											strokeWidth={box_size * 0.8}
											bezier={false} />
									)
								})}

								{(this.state.end_line.x !== false) && (
									<Line
										points={[pointer_ini_x, pointer_ini_y, pointer_x, pointer_y]}
										stroke={'rgba(' + color_ok + ', 0.5)'}
										lineCap='round'
										strokeWidth={box_size * 0.6}
										bezier={false} />
								)}

								<Group ref='letters'>
									{puzzle.map((row, y) => {
										return (
											row.map((letter, x) => {
												const init_x = box_size * Math.floor((count_word) % this.state.columns);
												const init_y = box_size * Math.floor((count_word) / this.state.columns);
												count_word += 1;
												if(!letter)return null;
												return (
													<Text
														key={x + '_' + y + '_l'}
														id={x + '_' + y + '_l'}
														x={init_x}
														y={init_y + box_size * 0.05}
														width={box_size}
														height={box_size}
														fontSize={box_size * 0.6}
														fontFamily='Helvetica'
														fill={text_color}
														//fill={(theme == 'light') ? 'black' : 'white'}
														wrap='char'
														align='center'
														verticalAlign='middle'
														text={letter.toUpperCase()} />
												)
											})
										)
									})}
								</Group>

								{puzzle.map((row, y) => {
									return (
										row.map((letter, x) => {
											var init_x = box_size * Math.floor((count_bg) % this.state.columns);
											var init_y = box_size * Math.floor((count_bg) / this.state.columns);
											count_bg += 1;

											const Element = (this.state.move_direction === false) ? Circle : Rect;
											const helper_size = (this.state.move_direction === false) ? box_size * 0.8: box_size;

											const pos_x = (this.state.move_direction === false) ? init_x + box_size / 2 : init_x;
											const pos_y = (this.state.move_direction === false) ? init_y + box_size / 2 : init_y;

											return (
												<Element
													key={x + '_' + y + '_bg'}
													x={pos_x}
													y={pos_y}
													radius={box_size / 2}
													width={helper_size}
													height={helper_size}
													pos_x={x}
													pos_y={y}
													fill='transparent'
													shadowBlur={0}
													onMouseOver={this.handleMouseOver.bind(this)}
													onTouchMove={this.handleMouseOver.bind(this)}
													onMouseUp={this.handleMouseUp.bind(this)}
													onTouchEnd={this.handleMouseUp.bind(this)}
													onMouseDown={this.handleMouseDown.bind(this)}
													onTouchStart={this.handleMouseDown.bind(this)} />
											)
										})
									)
								})}

								{(this.zoom_helper_enabled) && (
									<Group
										ref="mobile_zoom"
										visible={this.state.display_zoom_helper}
										x={(zoom_area_radius + box_size / 2) * ((this.state.zoom_helper.x_inverted) ? 1 : -1)}
										y={(zoom_area_radius + box_size / 2) * ((this.state.zoom_helper.y_inverted) ? 1 : -1)}>
										<Line
											points={[pointer_x, pointer_y, pointer_x - (zoom_area_radius + box_size / 2) * ((this.state.zoom_helper.x_inverted) ? 1 : -1), pointer_y - (zoom_area_radius + box_size / 2) * ((this.state.zoom_helper.y_inverted) ? 1 : -1)]}
											stroke={'rgb(' + color_ok + ')'}
											lineCap='round'
											strokeWidth={10} />

										<Group
											ref="mobile_zoom_clip"
											clipFunc={(ctx) => {
												ctx.arc(pointer_x, pointer_y, zoom_area_radius, 0, Math.PI * 2, false);
											}}
											x={pointer_x}
											y={pointer_y}
											offsetX={pointer_x}
											offsetY={pointer_y}>

											<Circle
												x={pointer_x}
												y={pointer_y}
												radius={zoom_area_radius}
												fill={(theme == 'light') ? 'rgb(200, 200, 200)' : 'rgb(50, 50, 50)'} />

											{this.state.result.found.map((word, w) => {
												if(word.found == undefined) return null;

												const x1 = word.start[0] * box_size + box_size / 2;
												const y1 = word.start[1] * box_size + box_size / 2;
												const x2 = word.end[0] * box_size + box_size / 2;
												const y2 = word.end[1] * box_size + box_size / 2;

												return (
													<Line
														key={'mob_' + w + '_sel'}
														points={[x1, y1, x2, y2]}
														stroke={'rgba(' + color_ok + ', 1)'}
														lineCap='round'
														strokeWidth={box_size * 0.8}
														bezier={false} />
												)
											})}

											{(this.state.display_zoom_helper) && (
												<Line
													points={[pointer_ini_x, pointer_ini_y, pointer_x, pointer_y]}
													stroke={'rgba(' + color_ok + ', 0.5)'}
													lineCap='round'
													strokeWidth={box_size * 0.6}
													bezier={false} />
											)}

											<Group ref='mob_letters'>
												{puzzle.map((row, y) => {
													return (
														row.map((letter, x) => {
															const init_x = box_size * Math.floor((count_word_mob) % this.state.columns);
															const init_y = box_size * Math.floor((count_word_mob) / this.state.columns);

															count_word_mob += 1;

															return (
																<Text
																	key={'mob_' + x + '_' + y + '_l'}
																	id={'mob_' + x + '_' + y + '_l'}
																	x={init_x}
																	y={init_y + box_size * 0.05}
																	width={box_size}
																	height={box_size}
																	fontSize={box_size * 0.6}
																	fill={(theme == 'light') ? 'black' : 'white'}
																	wrap='char'
																	align='center'
																	verticalAlign='middle'
																	text={letter.toUpperCase()} />
															)
														})
													)
												})}
											</Group>
										</Group>

										<Circle
											x={pointer_x}
											y={pointer_y}
											radius={zoom_area_radius}
											strokeWidth={3}
											stroke={'rgb(' + color_ok + ')'}
											fill='transparent'
											/>
									</Group>
								)}
							</Layer>
						</Stage>
					) : (
						<div class="gui_not_in_top gui_flex_center">
							<Spinner>Loading game</Spinner>
						</div>
					)}
				</div>

				{(display_legend) && (
					<Legend items={result.found} error_items={result.notFound} />
				)}
			</aside>
		)
	}
}

export default injectIntl(WordSearchCanvas);